import { create } from 'zustand';
import { RefundValues, SummaryShipment } from '../models/returns';

interface ISummaryContext {
  orderId: string;
  emailId: string;
  refundValues?: RefundValues;
  summaryShipments: SummaryShipment[] | undefined;
  hasDuplicateReturns?: boolean;
  selectedPickupDate?: string;
  isKeepIt?: boolean;
}

export const useSummaryStore = create<ISummaryContext>()(() => ({
  orderId: '',
  emailId: '',
  summaryShipments: undefined,
  hasDuplicateReturns: false,
  selectedPickupDate: undefined,
}));

export const setSummarySession = ({
  orderId,
  emailId,
  refundValues,
  summaryShipments,
  hasDuplicateReturns,
  selectedPickupDate,
  isKeepIt,
}: ISummaryContext) =>
  useSummaryStore.setState({
    orderId,
    emailId,
    refundValues,
    summaryShipments,
    hasDuplicateReturns,
    selectedPickupDate,
    isKeepIt,
  });

export const setRefundValues = (value: RefundValues | undefined) =>
  useSummaryStore.setState({ refundValues: value });

export const setSelectedPickupDate = (value?: string) =>
  useSummaryStore.setState({ selectedPickupDate: value });

export const _mockSummaryStore = (mockedState: Partial<ISummaryContext>) =>
  useSummaryStore.setState((state) => ({ ...state, ...mockedState }));
